{
  "removeButtonLabel": "Pašalinti",
  "removeDescription": "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
}
